/* eslint-disable no-param-reassign */
import { components } from "react-select";
import PropTypes from "prop-types";

const ValueContainer = ({ className, preserveStyle, children, ...otherProps }) => {
  if (!preserveStyle) {
    // So that the default styles aren't applied, for full customization
    otherProps.getStyles = () => ({});
  }

  return (
    <components.ValueContainer {...otherProps} className={className}>
      {children}
    </components.ValueContainer>
  );
};

ValueContainer.propTypes = {
  className: PropTypes.string,
  preserveStyle: PropTypes.bool,
  children: PropTypes.node,
};

ValueContainer.defaultProps = {
  className: "",
  preserveStyle: false,
  children: null,
};

export default ValueContainer;
